import React, { useEffect, useState } from "react";
import {
  Stack,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Breadcrumbs,
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";

const SidebarSection = ({ onCategorySelect }) => {
  const [activeSection, setActiveSection] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(""); // Track the selected category
  const resourcesList = ["Blog", "Academy"];

  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "http://192.168.29.113:5002/api/categories"
        );
        // console.log("categoryData:===>>>", response);
        setCategoryData(response?.data?.categories);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  // console.log("categoryData:========>>", categoryData);

  

  const categoriesList = [
    { name: "All", category: "All" },
    ...categoryData.map((item) => {
      const formattedName =
        item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
      return {
        name: formattedName,
        category: item,
      };
    }),
  ];

  // console.log("categoriesList1:====>>>", categoriesList);

 

  const handleSectionClick = (section) => {
    setActiveSection((prev) => (prev === section ? "" : section)); // Toggle visibility
  };
  const handleCategoryClick = (category) => {
    setSelectedCategory(category); // Update selected category
    onCategorySelect(category); // Pass the selected category to BlogSection1
  };

  return (
    <Stack
      sx={{
        // border: "1px solid #ddd",
        padding: "16px",
        // borderRadius: "8px",
        backgroundColor: "#edf9ff",
        // backgroundColor: "#fff",
      }}
    >
      {/* <Typography>Blogs</Typography> */}
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Blogs
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/material-ui/getting-started/installation/"
        >
          Category
        </Link>
        <Typography sx={{ color: "text.primary" }}>
          {" "}
          {categoriesList.find((item) => item.category === selectedCategory)
            ?.name || "All"}
        </Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 2, color: "transparent" }} />

      {/* Categories Section */}
      <Typography
        onClick={() => handleSectionClick("categories")}
        sx={{
          cursor: "pointer",
          fontWeight: "bold",
          marginBottom: "8px",
          display: "flex",
          alignItems: "center",
        }}
      >
        🔖 Categories
      </Typography>
      {activeSection === "categories" && (
        <List>
          {categoriesList.map((item, index) => (
            <ListItem
              key={index}
              sx={{
                padding: "4px 0",
                cursor: "pointer",
                padding: "8px 16px",
                cursor: "pointer",
                backgroundColor:
                  selectedCategory === item.category ? "#000" : "transparent", // Selected background color
                color: selectedCategory === item.category ? "#fff" : "#000", // Selected text color
                "&:hover": {
                  backgroundColor:
                    selectedCategory === item.category ? "#000" : "#f4f4f4", // Hover background color
                  color: selectedCategory === item.category ? "#fff" : "#000", // Hover text color
                },
                borderRadius: "4px",
              }}
              onClick={() => handleCategoryClick(item.category)}
            >
              <ListItemText primary={item.name} />
            </ListItem>
          ))}
        </List>
      )}
    </Stack>
  );
};

export default SidebarSection;
